
<template>
  <div>
    <Form ref="editModel" :model="editModel" :label-width="110">
      <FormItem label="最后更新时间：">{{
        editModel.lastUpdateDate
      }}</FormItem>
      <FormItem label="机构编码：">{{ editModel.organCode }}</FormItem>
      <FormItem label="序列日期：">{{ editModel.seriesDate }}</FormItem>
      <FormItem label="序列时间：">{{ editModel.seriesTime }}</FormItem>
      <FormItem label="序列描述：">{{ editModel.seriesDescription }}</FormItem>
      <FormItem label="序列ID：">{{ editModel.seriesID }}</FormItem>
      <FormItem label="SERIESUID：">{{ editModel.seriesInstanceUID }}</FormItem>
      <FormItem label="序列类型：">{{
        editModel.seriesModality
      }}</FormItem>
      <FormItem label="序列编号：">{{ editModel.seriesNumber }}</FormItem>
      <!-- <FormItem label="字典类别代码：">{{ editModel.studyID }}</FormItem> -->
      <!-- <FormItem label="字典类别名称：">{{
        editModel.studyInstanceUID
      }}</FormItem> -->
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      editModel: {},
    };
  },

  created: function () {
    this.editModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>